import { render } from "./Assignment6.vue?vue&type=template&id=3fcc1fab"
import script from "./Assignment6.vue?vue&type=script&lang=js"
export * from "./Assignment6.vue?vue&type=script&lang=js"

import exportComponent from "/Users/engkhiongsoh/dev/marketanalysis/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__